export default __webpack_public_path__ + "static/media/HamburgerPRO.98662c51.jpg";